export default {
  record_video_label: 'Record a Video',
  upload_video_label: 'Upload a Video',
  submit: 'Submit',
  upload_in_progess: 'Please wait as your video is uploaded. This might take a few minutes.',
  error_alert_title: 'Upload Error',
  retry_button_label: 'Retry Upload',
  start_recording_label: 'Start Recording',
  stop_recording_label: 'Stop Recording',
  cancel_label: 'Cancel'
};



// WEBPACK FOOTER //
// ./src/translations/en.js